export default __webpack_public_path__ + "static/media/login.1b317e9a.svg";